/**
 * 디바이더 컴포넌트 d
 * https://www.figma.com/file/TJGOBLk3lZBBvLnrdThGqs/MobileApp-UI-Component?node-id=338%3A311
 */

import Line from './Line';
import Section from './Section';

export type { LineDividerProps } from './Line/LineDivider';
export type { SectionDividerProps } from './Section/SectionDivider';

export default {
  Section,
  Line
};
